import React from 'react';
import { Button } from '../ui/button';
import { CriticalStockMachine } from '../../lib/types';
import { formatPercentage } from '../../lib/export';

interface CriticalStockMachinesTableProps {
  data: CriticalStockMachine[];
  onSeeAll: () => void;
  className?: string;
}

export function CriticalStockMachinesTable({ data, onSeeAll, className = '' }: CriticalStockMachinesTableProps) {
  const displayData = data.slice(0, 10);

  return (
    <div className={`bg-white p-6 rounded-lg shadow ${className}`}>
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Machines with Critical Stock</h3>
        <Button variant="outline" size="sm" onClick={onSeeAll}>
          See All
        </Button>
      </div>
      <p className="text-sm text-gray-600 mb-4">{data.length} Machines</p>
      
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 font-medium text-gray-900">Machine Name</th>
              <th className="text-left py-3 px-4 font-medium text-gray-900">Sub-Operator</th>
              <th className="text-right py-3 px-4 font-medium text-gray-900">Stock Level %</th>
              <th className="text-right py-3 px-4 font-medium text-gray-900">RoS</th>
            </tr>
          </thead>
          <tbody>
            {displayData.map((machine) => (
              <tr key={machine.machineId} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-3 px-4 text-sm font-medium text-gray-900">{machine.machineName}</td>
                <td className="py-3 px-4 text-sm text-gray-600">{machine.subOperator}</td>
                <td className="py-3 px-4 text-sm text-right">
                  <span className={`font-medium ${
                    machine.stockLevel < 20 ? 'text-red-600' : 
                    machine.stockLevel < 50 ? 'text-yellow-600' : 'text-green-600'
                  }`}>
                    {formatPercentage(machine.stockLevel, 1)}
                  </span>
                </td>
                <td className="py-3 px-4 text-sm text-right text-gray-900">{machine.ros.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
